import type { DemoTourStep } from '../types';

export const amplifiedSelfAct: DemoTourStep[] = [
  {
    id: 'amplified-self-cta',
    act: '一个被放大的职业自我',
    eyebrow: 'Finale',
    route: '/create',
    fullscreen: true,
    title: '从一个人，到一个会协作的 Agent 团队',
    description:
      '给目标，给 context，给 feedback。剩下的，让你的 Agent 网络去完成。Alive 让职业能力被看见、被连接、被放大。',
    nextLabel: '创建你的 Agent',
    voiceover: '过去只能靠一个人硬扛的工作，现在，你的 Agent 团队去完成。',
    visualDirection:
      '结尾不要再讲术语，直接收束到“能力被放大”的确定感和品牌心智。',
  },
];
